/**
 * @ngdoc directives
 * @memberof mercury.modules.stock.purchaseorder
 * @name inputpayrate
 * @description special input used on Staff Clocks page for Full Payroll users.
 */
angular.module('mercury.modules.stock.purchaseorder')
.directive('editfreighttax', function() {
  return {
    restrict: 'A',
    scope: true,
    templateUrl: 'modules/stock/purchaseorder/editfreighttax.tpl.html',
    link: function(scope) {
      scope.popoverOpen = false;
      scope.currentFreightTaxRate = -1;
      var isInitialized = false;

      scope.initializeTaxes = function() {
        if (isInitialized) {
          return;
        }

        scope.taxReady.then(function() {
          angular.forEach(scope.taxRates.data, function(taxRate) {
            if (taxRate.amount == scope.order.freightTaxPercent) {
              scope.currentFreightTaxRate = taxRate.rate;
            }
            if (!scope.customFreightTaxPercent) {
              scope.customFreightTaxPercent = scope.order.freightTaxPercent;
            }
          });
        });
        isInitialized = true;
      };

      scope.changeFreightTaxRate = function() {
        if (scope.currentFreightTaxRate === -1) {
          scope.order.freightTaxPercent = scope.customFreightTaxPercent;
        } else {
          angular.forEach(scope.taxRates.data, function(taxRate) {
            if (taxRate.rate == scope.currentFreightTaxRate) {
              scope.order.freightTaxPercent = taxRate.amount;
            }
          });
        }
        scope.orderEditTotal();
      };

      scope.getTaxAmount = function(rateAmount) {
        return scope.order.freight * rateAmount;
      };

      scope.initializeTaxes();
    }
  };
});
